import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';

import Space from './Space.container';

const SpaceWithFeatureFlag = (props) => {
  const {
    adminFtOpenSpaceToggleEnabled202108,
    webAppFtLoginRedirectNewOld112025,
  } = useFlags();
  return (
    <Space
      showOpenSpaceFeatureFlag={adminFtOpenSpaceToggleEnabled202108}
      redirectToOldOrNewLandingPageFlag={webAppFtLoginRedirectNewOld112025}
      {...props}
    />
  );
};

export default SpaceWithFeatureFlag;
